"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChainContractAddress = void 0;
const chain_js_1 = require("../../errors/chain.js");
function getChainContractAddress(_ref) {
  var _chain$contracts;
  let {
    blockNumber,
    chain,
    contract: name
  } = _ref;
  const contract = chain === null || chain === void 0 || (_chain$contracts = chain.contracts) === null || _chain$contracts === void 0 ? void 0 : _chain$contracts[name];
  if (!contract) throw new chain_js_1.ChainDoesNotSupportContract({
    chain,
    contract: {
      name
    }
  });
  if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new chain_js_1.ChainDoesNotSupportContract({
    blockNumber,
    chain,
    contract: {
      name,
      blockCreated: contract.blockCreated
    }
  });
  return contract.address;
}
exports.getChainContractAddress = getChainContractAddress;
//# sourceMappingURL=getChainContractAddress.js.map